import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    searchCustomerForms: {},
    searchPotentialCustomerForms: {},
    searchLeadForms: {},

    policiesPerPage: {},
    currentPoliciesPage: 1,
    policiesLoading: false,
    searchPoliciesForms: {},
  },
  getters: {
    searchCustomerForms: (state) => state.searchCustomerForms,
    searchPotentialCustomerForms: (state) => state.searchPotentialCustomerForms,
    searchLeadForms: (state) => state.searchLeadForms,

    policiesPerPage: (state) => state.policiesPerPage,
    currentPoliciesPage: (state) => state.currentPoliciesPage,
    policiesLoading: (state) => state.policiesLoading,

    searchPoliciesForms: (state) => state.searchPoliciesForms,
  },
  mutations: {
    setSearchCustomerForms: (state, data) => {
      state.searchCustomerForms = data;
    },
    setSearchPotentialCustomerForms: (state, data) => {
      state.searchPotentialCustomerForms = data;
    },
    setSearchLeadForms: (state, data) => {
      state.searchLeadForms = data;
    },

    setPoliciesPerPage: (state, data) => {
      state.policiesPerPage = data;
    },
    setCurrentPoliciesPage: (state, data) => {
      state.currentPoliciesPage = data;
    },

    setPoliciesLoading: (state, data) => {
      state.policiesLoading = data;
    },

    setSearchPoliciesForms: (state, data) => {
      state.searchPoliciesForms = data;
    }
  },
  actions: {
    searchPotentialCustomer: async (_, phone) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .get(`/v1/filter/potential-customers?phone=${phone}`)
          .then(
            (response) => {
              const [data] = response.data.data;
              resolve(data);
            },
            (err) => {
              reject(err);
            }
          );
      }),

    searchUsers: async ({ commit, dispatch }, { searchKeywords, selectedTeam, active_users, page = 1, isExport = false }) => {
      if (!isExport) commit("setUsersLoading", true);

      try {
        const url = page ? `/v1/search/users?page=${page}` : "/v1/search/users";

        const payload = {
          searchKeywords,
          selectedTeam,
          active_users,
          export: isExport
        };

        const response = await api({ requiresAuth: true }).post(url, payload, {
          responseType: isExport ? "blob" : "json",
        });

        if (isExport) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Users_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setUsersPerPage", response.data);
        }
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToSearchUsers"),
        });
      } finally {
        if (!isExport) commit("setUsersLoading", false);
      }
    },

    getSearchCustomerForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const idsArray = [].concat(teamIds);

        const query = idsArray
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-customers?${query}`
        );

        commit("setSearchCustomerForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadSearchCustomerForms"),
        });
      }
    },

    getSearchAddFamilyMemberForms: async ({ commit, dispatch }) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/search-family"
        );
        commit("setSearchCustomerForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadFamilySearchForms"),
        });
      }
    },

    getSearchPotentialCustomerForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const query = teamIds.map(id => `teams[]=${encodeURIComponent(id)}`).join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-potential-customers?${query}`
        );
        commit("setSearchPotentialCustomerForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadPotentialCustomerForms"),
        });
      }
    },

    getSearchLeadForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const idsArray = [].concat(teamIds);

        const query = idsArray
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-leads?${query}`
        );

        commit("setSearchLeadForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadLeadForms"),
        });
      }
    },

    searchPotentialCustomers: async ({ commit, dispatch }, { page, ...searchData }) => {
      commit("setCustomersLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching) {
          const url = page ? `/v1/search/potential-customers?page=${page}` : "/v1/search/potential-customers";
          response = await api({ requiresAuth: true }).post(url, searchData);
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/potential-customers?page=${page}`);
        }

        commit("setCustomersPerPage", response.data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToSearchPotentialCustomers"),
        });
      } finally {
        commit("setCustomersLoading", false);
      }
    },

    searchCustomers: async ({ commit, dispatch }, { page, ...searchData }) => {
      commit("setCustomersLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching || searchData.export) {
          const url = page ? `/v1/search/customers?page=${page}` : "/v1/search/customers";
          response = await api({ requiresAuth: true }).post(url, searchData, {
            responseType: searchData.export ? "blob" : "json"
          });
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/customers?page=${page}`);
        }

        if (searchData.export) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Customers_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setCustomersPerPage", response.data);
        }
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToSearchCustomers"),
        });
      } finally {
        commit("setCustomersLoading", false);
      }
    },

    searchLeads: async ({ commit, dispatch }, { page, ...searchData }) => {
      commit("setLeadsLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching || searchData.export) {
          const url = page ? `/v1/search/lead-customers?page=${page}` : "/v1/search/lead-customers";
          response = await api({ requiresAuth: true }).post(url, searchData, {
            responseType: searchData.export ? "blob" : "json"
          });
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/lead-customers?page=${page}`);
        }

        if (searchData.export) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Leads_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setLeadCustomersPerPage", response.data);
        }
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToSearchLeads"),
        });
      } finally {
        commit("setLeadsLoading", false);
      }
    },

    searchCustomerForFamily: async ({ dispatch }, { ...searchData }) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .post(`/v1/filter/family-customers`,
            searchData
          )
          .then(
            (response) => {
              const data = response.data.data;
              resolve(data);
            },
            (err) => {
              dispatch("showToast", {
                type: "error",
                message: err.response?.data?.message || t("messages.failedToSearchFamilyCustomers"),
              });
              reject(err);
            }
          );
      }),

    searchPolicies: async ({ commit, dispatch }, { page, ...searchData }) => {
      commit("setPoliciesLoading", true);
      try {
        let response = null;
        const teamsPresent = (searchData.teams && searchData.teams.length > 0) || (searchData.selectedTeam && searchData.selectedTeam.length > 0);

        const isSearching =
          (searchData.search && searchData.search.trim() !== "") ||
          (searchData.agents && searchData.agents.length > 0) ||
          (searchData.companies && searchData.companies.length > 0) ||
          (searchData.branchCategories && searchData.branchCategories.length > 0) ||
          (searchData.policyStatuses && searchData.policyStatuses.length > 0) ||
          teamsPresent ||
          searchData.startDateFrom ||
          searchData.startDateTo ||
          searchData.endDateFrom ||
          searchData.endDateTo ||
          searchData.submitDateFrom ||
          searchData.submitDateTo;

        const isExport = !!(searchData.isExport || searchData.export);

        const payload = { ...searchData };
        if (!payload.teams && payload.selectedTeam) payload.teams = payload.selectedTeam;

        if (isSearching) {
          let url = page ? `/v1/search/policies?page=${page}` : "/v1/search/policies";
          if (isExport) url += (url.includes("?") ? "&" : "?") + "export=true";
          response = await api({ requiresAuth: true }).post(url, payload, {
            responseType: isExport ? "blob" : undefined,
          });
        } else {
          let url = page ? `/v1/policies?page=${page}` : "/v1/policies";
          if (isExport) url += (url.includes("?") ? "&" : "?") + "export=true";
          response = await api({ requiresAuth: true }).get(url, {
            responseType: isExport ? "blob" : undefined,
          });
        }

        if (isExport) {
          if (response && response.data) {
            const blob = new Blob([response.data], { type: response.headers && response.headers['content-type'] ? response.headers['content-type'] : 'application/octet-stream' });
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Policies_export.xlsx');
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL);
          }
        } else {
          if (response && response.data) {
            commit("setPoliciesPerPage", response.data);
          }
        }
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToSearchPolicies"),
        });
      } finally {
        commit("setPoliciesLoading", false);
      }
    },

    getSearchPoliciesForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const query = teamIds.map(id => `teams[]=${encodeURIComponent(id)}`).join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-policies?${query}`
        );

        commit("setSearchPoliciesForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadSearchPolicyForms"),
        });
      }
    },
  },
};
